import React from 'react';
import { Button } from '../components/ui/button';

export const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl border-b border-gray-200" style={{ backgroundColor: 'rgba(255, 255, 255, 0.95)' }}>
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <span className="text-3xl font-black text-black tracking-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>ArcheanX</span>
          <div className="flex items-center gap-6">
            <nav className="hidden md:flex items-center gap-6">
              <a href="#home" className="text-gray-700 hover:text-orange-600 transition-colors" data-testid="nav-home">Home</a>
              <a href="#solution" className="text-gray-700 hover:text-orange-600 transition-colors" data-testid="nav-solution">Solution</a>
              <a href="#platform" className="text-gray-700 hover:text-orange-600 transition-colors" data-testid="nav-platform">Platform</a>
              <a href="#demo" className="text-gray-700 hover:text-orange-600 transition-colors" data-testid="nav-demo">Demo</a>
            </nav>
            <Button
              data-testid="header-get-started-btn"
              className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Get Started
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};
